import { defineComponent as r, useCssModule as l, toRef as a, provide as i, createElementBlock as m, openBlock as c, normalizeClass as p, unref as u, renderSlot as d } from "vue";
import { motionKey as f } from "../../types/symbols.mjs";
const C = "cdr-skeleton", S = /* @__PURE__ */ r({
  name: "CdrSkeleton",
  __name: "CdrSkeleton",
  props: {
    /**
       * Toggle animation on/off.
       * When `true`, animated gradient will be used while loading.
       * When `false` a static background color will be used.
       * Automatically disabled if `prefers-reduced-motion` is set by user.
    */
    motion: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const o = e, t = l(), n = a(o, "motion");
    return i(f, n), (s, k) => (c(), m("div", {
      class: p(u(t)[C]),
      "aria-live": "polite",
      "aria-busy": "true"
    }, [d(s.$slots, "default")], 2));
  }
});
export {
  S as default
};
